import { createLogger } from '@kurrent-ui/utils';

const logger = createLogger('@kurrent-ui/theme', 'radial-gradient( circle farthest-corner at 10% 20%,  rgba(253,193,104,1) 0%, rgba(251,128,128,1) 90% )');

export { logger };
